import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';

export const useAttendeeTicketCounts = () => {
  const { user } = useAuth();

  const { data: counts = { incidentes: 0, requisicoes: 0 } } = useQuery({
    queryKey: ['attendee-ticket-counts', user?.id],
    queryFn: async () => {
      if (!user?.id) return { incidentes: 0, requisicoes: 0 };

      // Buscar incidentes onde o usuário é atendente
      const { data: incidentes, error: incidentesError } = await supabase
        .from('incidentes')
        .select('id')
        .eq('atendente_id', user.id)
        .not('status', 'in', '("fechado","resolvida")');

      if (incidentesError) {
        console.error('Error fetching incidentes count:', incidentesError);
      }

      // Buscar requisições onde o usuário é atendente
      const { data: requisicoes, error: requisicoesError } = await supabase
        .from('solicitacoes')
        .select('id')
        .eq('atendente_id', user.id)
        .not('status', 'in', '("fechada","resolvida")');

      if (requisicoesError) {
        console.error('Error fetching requisições count:', requisicoesError);
      }

      return {
        incidentes: incidentes?.length || 0,
        requisicoes: requisicoes?.length || 0,
      };
    },
    enabled: !!user?.id,
    refetchInterval: 30000, // Refetch every 30 seconds
  });

  return counts;
};